import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getAffiliatesBannerSlidesStart,
  getAffiliatesBannerSlidesSuccess,
  getAffiliatesBannerSlidesFailed,
  addAffiliatesBannerSlideStart,
  addAffiliatesBannerSlideSuccess,
  addAffiliatesBannerSlideFailed,
  deleteAffiliatesBannerSlideStart,
  deleteAffiliatesBannerSlideSuccess,
  deleteAffiliatesBannerSlideFailed,
  editAffiliatesBannerSlideStart,
  editAffiliatesBannerSlideSuccess,
  editAffiliatesBannerSlideFailed,
  getFullfilmentBannerSlidesStart,
  getFullfilmentBannerSlidesSuccess,
  getFullfilmentBannerSlidesFailed,
  addFullfilmentBannerSlideStart,
  addFullfilmentBannerSlideSuccess,
  addFullfilmentBannerSlideFailed,
  deleteFullfilmentBannerSlideStart,
  deleteFullfilmentBannerSlideSuccess,
  deleteFullfilmentBannerSlideFailed,
  editFullfilmentBannerSlideStart,
  editFullfilmentBannerSlideSuccess,
  editFullfilmentBannerSlideFailed,
  getAffiliateProvidersStart,
  getAffiliateProvidersSuccess,
  getAffiliateProvidersFailed,
  getStoreAffiliatesStart,
  getStoreAffiliatesSuccess,
  getStoreAffiliatesFailed,
  addAffiliateToStoreStart,
  addAffiliateToStoreSuccess,
  addAffiliateToStoreFailed,
  sendRequestProductsEmailStart,
  sendRequestProductsEmailFailed,
  sendRequestProductsEmailSuccess,
} from 'redux/actions/partners';


export const getAffiliatesBannerSlidesApi = async ({dispatch}) => {
  try {
    dispatch(getAffiliatesBannerSlidesStart());
    const { data } = await api.get(`${shopManagerApi}/partners/affiliate/banners`);
    dispatch(getAffiliatesBannerSlidesSuccess(data));
  } catch (e) {
    dispatch(getAffiliatesBannerSlidesFailed(e));
  }
};

export const addAffiliatesBannerSlideApi = async ({dispatch, formData}) => {
  try {
    dispatch(addAffiliatesBannerSlideStart());
    const { data } = await api.post(`${shopManagerApi}/partners/affiliate/banners`, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
    dispatch(addAffiliatesBannerSlideSuccess(data));
  } catch (e) {
    dispatch(addAffiliatesBannerSlideFailed(e));
  }
};

export const deleteAffiliatesBannerSlideApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteAffiliatesBannerSlideStart());
    await api.delete(`${shopManagerApi}/partners/affiliate/banners/${id}`);
    dispatch(deleteAffiliatesBannerSlideSuccess(id));
  } catch (e) {
    dispatch(deleteAffiliatesBannerSlideFailed(e));
  }
};

export const editAffiliatesBannerSlideApi = async ({dispatch, formData, id}) => {
  try {
    dispatch(editAffiliatesBannerSlideStart());
    const {data} = await api.patch(`${shopManagerApi}/partners/affiliate/banners/${id}`, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
    dispatch(editAffiliatesBannerSlideSuccess(data, id));
  } catch (e) {
    dispatch(editAffiliatesBannerSlideFailed(e));
  }
};

export const getFullfilmentBannerSlidesApi = async ({dispatch}) => {
  try {
    dispatch(getFullfilmentBannerSlidesStart());
    const { data } = await api.get(`${shopManagerApi}/partners/fullfilment/banners`);
    dispatch(getFullfilmentBannerSlidesSuccess(data));
  } catch (e) {
    dispatch(getFullfilmentBannerSlidesFailed(e));
  }
};

export const addFullfilmentBannerSlideApi = async ({dispatch, formData}) => {
  try {
    dispatch(addFullfilmentBannerSlideStart());
    const { data } = await api.post(`${shopManagerApi}/partners/fullfilment/banners`, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
    dispatch(addFullfilmentBannerSlideSuccess(data));
  } catch (e) {
    dispatch(addFullfilmentBannerSlideFailed(e));
  }
};

export const deleteFullfilmentBannerSlideApi = async ({dispatch, id}) => {
  try {
    dispatch(deleteFullfilmentBannerSlideStart());
    await api.delete(`${shopManagerApi}/partners/fullfilment/banners/${id}`);
    dispatch(deleteFullfilmentBannerSlideSuccess(id));
  } catch (e) {
    dispatch(deleteFullfilmentBannerSlideFailed(e));
  }
};

export const editFullfilmentBannerSlideApi = async ({dispatch, formData, id}) => {
  try {
    dispatch(editFullfilmentBannerSlideStart());
    const {data} = await api.patch(`${shopManagerApi}/partners/fullfilment/banners/${id}`, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
    dispatch(editFullfilmentBannerSlideSuccess(data, id));
  } catch (e) {
    dispatch(editFullfilmentBannerSlideFailed(e));
  }
};

export const getAffiliateProvidersApi = async ({dispatch}) => {
  try {
    dispatch(getAffiliateProvidersStart());
    const { data } = await api.get(`${shopManagerApi}/partners/affiliate/providers`);
    dispatch(getAffiliateProvidersSuccess(data));
  } catch (e) {
    dispatch(getAffiliateProvidersFailed(e));
  }
};

export const getStoreAffiliatesApi = async ({dispatch}) => {
  try {
    dispatch(getStoreAffiliatesStart());
    const { data } = await api.get(`${shopManagerApi}/partners/store/affiliates`);
    dispatch(getStoreAffiliatesSuccess(data));
  } catch (e) {
    dispatch(getStoreAffiliatesFailed(e));
  }
};

export const addAffiliateToStoreApi = async ({dispatch, affiliateData}) => {
  try {
    dispatch(addAffiliateToStoreStart());
    const { data } = await api.post(`${shopManagerApi}/partners/store/affiliates`, affiliateData);
    dispatch(addAffiliateToStoreSuccess(data));
  } catch (e) {
    dispatch(addAffiliateToStoreFailed(e));
  }
};

export const sendRequestProductsEmailApi = async ({dispatch, requestedProducts}) => {
  try {
    dispatch(sendRequestProductsEmailStart());
    await api.post(`${shopManagerApi}/fulfillment/request-products`, requestedProducts);
    dispatch(sendRequestProductsEmailSuccess());

    return true;
  } catch (e) {
    dispatch(sendRequestProductsEmailFailed(e));

    return false;
  }
};
